import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { Router } from '@angular/router';
import { PostLoginStatusComponent } from '../shared/post-login-status/post-login-status.component';

/**
 * OAuth Callback Component
 * Handles the redirect from Azure AD after authentication
 * 
 * Route: /auth/callback
 */
@Component({
  selector: 'app-auth-callback',
  standalone: true,
  imports: [PostLoginStatusComponent],
  template: `
    <div class="callback-container">
      <div class="callback-content">
        <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
        <h2>{{ errorMessage ? 'Accesso negato' : 'Autenticazione in corso...' }}</h2>

        <!-- Live status messages (post-login steps + denial reasons) -->
        <div style="margin-top: 1.5rem; max-width: 480px; text-align: left;">
          <app-post-login-status />
        </div>

        @if (errorMessage) {
          <p class="error-message">{{ errorMessage }}</p>
        }
      </div>
    </div>
  `,
  styles: [`
    .callback-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    }
    
    .callback-content {
      text-align: center;
      color: white;
      padding: 2rem;
    }
    
    .callback-content h2 {
      margin-top: 1rem;
      font-size: 1.5rem;
    }
    
    .error-message {
      color: #ff6b6b;
      margin-top: 1rem;
      padding: 1rem;
      background: white;
      border-radius: 4px;
    }
  `]
})
export class AuthCallbackComponent implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);

  errorMessage: string | null = null;

  async ngOnInit() {
    try {
      const success = await this.authService.handleCallback();

      if (!success) {
        const denialReason = this.authService.accessDenialReason$.getValue();
        this.errorMessage = denialReason ?? 'Autenticazione fallita. Riprova.';
        setTimeout(() => this.router.navigate(['/login']), 3000);
      }
    } catch (error) {
      console.error('Error in auth callback:', error);
      this.errorMessage = 'Errore durante l\'autenticazione.';
      setTimeout(() => this.router.navigate(['/login']), 3000);
    }
  }
}
